export const TrashIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    color="#D6453B"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      clipPath="url(#clip0_19723_14823)"
    >
      <path d="M6.667 8.334h6.667M12.709 8.334v4.795c0 .574-.448 1.038-1 1.038H8.292c-.552 0-.999-.465-.999-1.038V8.334M11.25 6.25h-2.5"></path>
      <path d="M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697"></path>
    </g>
    <defs>
      <clipPath id="clip0_19723_14823">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
